export default {"src":"/_next/static/media/cuisine_image.0c1e9470.svg","height":26,"width":26,"blurWidth":0,"blurHeight":0};